export const environment = {
  production: true,
  API_URL: 'https://dev-back.corefluens.co/api/',
  enterprise: "wedevel",
  api_username: 'client',
  api_password: 'Dzj4v84Zn1Vh',
  enable_seas: true
};
